module.exports = __webpack_public_path__ + "static/img/MU@3x.a62b15b9.jpg";